import { HStack, useTheme, Text } from '@chakra-ui/react';

const PalommaDisclaimer = (): JSX.Element => {
  const theme = useTheme();
  return (
    <HStack spacing={2}>
      <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M27.2411 15.2449C27.2411 15.2449 28.7877 12.5442 28.1727 10.5782C28.1475 10.4956 28.1188 10.4164 28.0919 10.3372C28.0649 10.2614 28.0363 10.1873 28.006 10.1132C27.2916 8.37453 25.6018 7.23228 23.7267 7.10761L21.4119 6.9543L21.2586 4.63947C21.1339 2.76436 19.9917 1.07457 18.253 0.360247C18.1789 0.329922 18.1048 0.301281 18.029 0.274326C17.9498 0.24737 17.8706 0.218729 17.788 0.193458C15.822 -0.42147 13.1213 1.12512 13.1213 1.12512L0.366211 7.80003C1.53036 9.98176 4.17371 10.8747 6.40767 9.88573C6.4481 9.97671 6.49022 10.066 6.53739 10.1553C7.70997 12.3977 10.4392 13.2973 12.7069 12.2241C12.8113 13.0615 13.182 13.8718 13.8239 14.5137C14.4657 15.1556 15.3014 15.538 16.1522 15.6357C15.0621 17.9084 15.9618 20.6512 18.2109 21.8288C18.3002 21.876 18.3895 21.9181 18.4805 21.9585C17.4915 24.1908 18.3844 26.8358 20.5662 28L27.2411 15.2449Z"
          fill={theme.colors.palomma.primary.logo}
        />
      </svg>
      <Text color={'palomma.primary.logo'}>Pagos seguros por Palomma</Text>
    </HStack>
  );
};

export default PalommaDisclaimer;
